<template>
  <div>
    <Input
      placeholder="请选择"
      readonly
      v-model="name"
      @on-focus="open"
      clearable
      @on-clear="clear"
    ></Input>
    <Drawer
      width="340"
      class="my-drawer"
      title="车辆类型"
      footer-hide
      v-model="openDrawer"
    >
      <ul class="cartypelist">
        <li @click="change(item)" v-for="(item, index) in list" :key="index">
          <h4>{{ item.name }}</h4>
          <div>
            <span
              >满载规格：{{ item.kgs }}KGS，{{ item.cbm }}CBM，{{
                item.pl
              }}P/L</span
            >
          </div>
        </li>
      </ul>
    </Drawer>
  </div>
</template>
<script>
export default {
  props: ["pdata"],
  model: {
    prop: "pdata",
    event: "aaa",
  },
  data() {
    return {
      list: [],
      name: "",
      openDrawer: false,
    };
  },
  methods: {
    open() {
      this.openDrawer = true;
      this.getList();
    },
    change(v) {
      this.name = v.name;
      this.$emit("aaa", v.name);
      this.$emit("bbb", v);
      this.openDrawer = false;
    },
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.dm + "/carType/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          var t = data[i].extend;
          for (const j in t) {
            data[i][j] = t == null ? "" : t[j];
          }
        }
        this.list = data;
      });
    },
    clear(){
      this.$emit("aaa", '');
    }
  },
  mounted() {
    this.name = this.pdata;
  },
  watch: {
    pdata(v) {
      this.name = v;
    },
  },
};
</script>
<style>
.cartypelist li {
  cursor: pointer;
  padding: 5px;
  display: flex;
}
.cartypelist li:hover {
  background: #ebf5ff;
}
.cartypelist li h4 {
  font-weight: bold;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/common/selectCarType.vue